module.exports = "/assets/4a3249a5b1d9b843cd4efa0578646ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3Y.png
// module id = 1025
// module chunks = 0